/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
import { DMNNM } from '../configs/ops';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class ExchangeTennisSEO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }



    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <div className="radheexch radheexchlogin bg-white-login ">


                <Loginb2cHeader history={this.props.history}></Loginb2cHeader>
                {/* <div className='login-mar-top100'>
            <section className='sportbook-screen'>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen.jpg"} className="sp-desktop-show" /></a>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen-mobile.jpg"} className="sp-mobile-show" /></a>
            </section>
        </div> */}
                <div className='login-mar-top100 '>
                    <section className='sportbook-livecasino'>
                        <div>
                            <img alt="Exchange Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchanges-banner.jpg"} />

                        </div>
                        <div>
                            <div className="">
                                <div className='seo-content-page'>
                                    <h2 align="center">{DMNNM} – The Best Place To Play and Earn With Tennis</h2>
                                    <p>
                                        <strong>Are You A Tennis Lover? Bet Your Heart On It!</strong>
                                    </p>
                                    <p>
                                        It's the season, the Tennis games are on - the world-class players are on
                                        the court ready to serve, but you have a feeling that you already know who
                                        the winner is going to be? Does that happen to you? Well, if you have    <strong>Tennis</strong> in your mind or heart, you can see things. And you
                                        can bet money on it - and make money while you are enjoying the game.
                                    </p>
                                    <p>
                                        For Tennis fans, Tennis is one of the best <strong>online sports</strong>.
                                        With digitalization and penetration of the internet, online games are
                                        becoming more and more popular. You, too, can have<strong>fun gaming online</strong>. {DMNNM} is the best place for<strong>online Tennis betting</strong>. All you need is an    <strong>online Tennis id </strong>for the purpose.
                                    </p>
                                    <p>
                                        <strong>Tennis Betting - All You Need To Know</strong>
                                    </p>
                                    <p>
                                        To <strong>Tennis</strong> enthusiasts, all that happens on the two sides
                                        of the net are like works of art. An    <strong>online Tennis betting game </strong>is the perfect way to pass the
                                        time for them. If you are one such player, then you will have    <strong>fun gaming online</strong>. If you think you have a good mind about
                                        how Tennis games are going to be, <strong>online Tennis betting </strong>
                                        may be a perfect way of spicing up your fun.
                                    </p>
                                    <p>
                                        There are several perks to <strong>Tennis </strong>betting. If you have the
                                        brains to understand the game, it can help you make a lot of money, but
                                        there is a lot more to it than that. It fills one with a sense of
                                        adventure, and it actually helps one feel more invested in the Tennis game
                                        if one's money is in it.
                                    </p>
                                    <p>
                                        People have bet on games for centuries. <strong>Online sports </strong>have
                                        just made it more fun. Moreover, betting is not without some skills of its
                                        own involved. There is a learning curve, and several people do make money
                                        in it.
                                    </p>
                                    <p>
                                        And it is perfectly legal too. <strong>Online Tennis betting </strong>or
                                        betting of any kind is perfectly legal as long as you. As long as you are
                                        an adult and of sound mind, you can go for betting with a clean conscience.    <strong>Online Tennis betting </strong>is only a vice if it is addictive.
                                    </p>
                                    <p>
                                        <strong>Online Cricket Is Even More Fun</strong>
                                    </p>
                                    <p>
                                        Ever since the internet was first invented, online games have been here,
                                        and they are growing exponentially as computing powers grow with every
                                        machine. The <strong>online Tennis betting game </strong>is simply a lot
                                        more convenient and comfortable - you can do the betting from the comfort
                                        of your home. All you need is a good, stable internet connection and a
                                        device to access it.
                                    </p>
                                    <p>
                                        All you need is an <strong>online Tennis id </strong>for the purpose, and
                                        you are good to go. One of the leading perks of online Tennis games is that
                                        it is a lot more fun than traditional betting. From various    <strong>online sports</strong>, it is one of the easiest games to bet on.
                                        And the rewards are much better when playing online.
                                    </p>
                                    <p>
                                        Unlike conventional betting, online betting platforms are a lot better
                                        regulated and are under public scrutiny. Thus, you don't have to worry
                                        about being cheated when playing an    <strong>online Tennis betting game</strong>.
                                    </p>
                                    <p>
                                        <strong>The Perfect Place For Tennis Betting</strong>
                                    </p>
                                    <p>
                                        It is, of course, of critical importance to choose your platform well,
                                        whether you are betting or just <strong>having fun gaming online</strong>,
                                        as platforms aren't all the same and offer very different quality of
                                        customer experience. You can conduct your research to find the best    <strong>online Tennis betting</strong>, or you can take our word for it -
                                        {DMNNM} is simply the best <strong>Online Tennis betting game </strong>
                                        platform you will find. And there are several reasons for supporting this
                                        claim. Let us look at some of these reasons.
                                    </p>
                                    <p>
                                        ● Our platform provides an immersive experience for    <strong>fun gaming online</strong>.
                                    </p>
                                    <p>
                                        ● Betting with us is supercontinent, and we know how to make the process
                                        smooth. You can easily check your bets with the bet slip we provide on our
                                        website.
                                    </p>
                                    <p>
                                        ● We provide an opportunity for having an    <strong>online Tennis betting game </strong>for all kinds of Tennis
                                        matches. All you need is an <strong>Online Tennis id</strong>.
                                    </p>
                                    <p>
                                        ● We offer the most lucrative bets you will find in the market - whether
                                        online or offline.
                                    </p>
                                    <p>
                                        ● All your payments and receipts are safe. They are all done through safe
                                        routes as your financial and other private information is safe with us.
                                    </p>
                                    <p>
                                        ● Your financial and private information is also safe with us.
                                    </p>
                                    <p>
                                        ● Tennis is only one of our various <strong>fun gaming online </strong>
                                        experiences. You can also try out other sports such as cricket, football,
                                        etc.
                                    </p>
                                    <p>
                                        ● Moreover, you can play all these <strong>online sports </strong>only
                                        needing Indian money.
                                    </p>
                                    <p>
                                        ● In case you have any other doubts or queries, you can also chat with us
                                        on our website online or contact us through the social media link of your
                                        choice from those provided on the website.
                                    </p>
                                    <p>
                                        <strong>Essential Tips For Tennis Betting</strong>
                                    </p>
                                    <p>
                                        When it comes to <strong>online sports</strong>, a lot of people may not
                                        know how to bet on Tennis. To help them improve their odds, we have a few
                                        tips to recommend. These tips can help them in avoiding amateurish errors;
                                        These tips are particularly good for new players in particular. Let us go
                                        into them in detail:
                                    </p>
                                    <p>
                                        ● <strong>Know your game well</strong> - The knowledge of    <strong>Tennis </strong>- its various rules, players, their form, etc. play
                                        an important part. In fact, they are your most valuable asset when it comes
                                        to betting. Without this knowledge, you will be betting blinds which
                                        significantly reduces the chances of your winning the game. It is thus
                                        crucial that you should develop knowledge of the game; while those playing
                                        without knowledge of the sport may occasionally get lucky, they are likely
                                        to lose money in the long run.
                                    </p>
                                    <p>
                                        ● <strong>Learning online Tennis takes time</strong> - Patience is another
                                        important virtue that a player should process. While you can start playing
                                        as soon as you have an <strong>online Tennis id</strong>, it will take a
                                        lot of time to study the various intricacies of the game properly to get
                                        the results. It is thus always a wise strategy to only make small bets at
                                        the beginning.
                                    </p>
                                    <p>
                                        ● <strong>Understand your financial limits</strong> - It is also crucial
                                        that you should understand your financial limits. It is important to have
                                        an upper limit on the amount of money you are willing to bet in a day,
                                        week, or month - and to respect that limit. Even good players had lost too
                                        much money when they didn't show desirable self-restrain.
                                    </p>
                                    <p>
                                        <strong>Moral Responsibilities While Online Betting</strong>
                                    </p>
                                    <p>
                                        For ensuring that your <strong>Tennis </strong>betting stays within healthy
                                        limits and won't be harmful to you or your loved ones, it is important to
                                        understand the ethics surrounding the game. The following discussion will
                                        help you get a complete picture in this regard.
                                    </p>
                                    <p>
                                        ● <strong>Legal aspects</strong> - We have already mentioned that you can
                                        get an <strong>online Tennis id</strong>as long as you are an adult and of
                                        sound mind. It is important to keep those who do not fulfill these
                                        conditions away from gambling. Children, in particular, may not be
                                        sufficiently self-disciplined for betting.
                                    </p>
                                    <p>
                                        ● <strong>Ensure that you can show financial responsibility</strong> - If
                                        you want to bet in online Tennis games, then know that it is not all just
                                        about fun and no responsibility. It is a financial decision, and like all
                                        kinds of financial decisions, it will involve its own risks, and thus you
                                        do stand a chance of losing money. We caution that you should always act
                                        with financial prudence. Thus, no matter how good you may believe you are
                                        in online betting, you should not bet a sum that you will regret losing.
                                        That's why we suggest financial tips.
                                    </p>
                                    <p>
                                        ● <strong>Know when to ask for help</strong> - Self-discipline is highly
                                        crucial when you are betting. If you are betting more than you originally
                                        planned on a consistent basis, you need to stop betting altogether.
                                        Gambling is not for everyone, and it just is not for you. If you are still
                                        unable to stop, it is important that you should not be afraid to ask for
                                        help.
                                    </p>
                                    <p>
                                        ● <strong>Gambling is not alternative to your chief employment</strong> -
                                        Gambling is good for fun, but it cannot replace your day job as you can
                                        never and should never count on winning all the time. It is important to
                                        think of online Tennis betting as a mere fun way of passing the time and no
                                        more. Any money you do win should be considered a bonus.
                                    </p>
                                    <p>
                                        As long as you follow these ethical guidelines, you will have no problems.
                                    </p>
                                    <p>
                                        <strong>The Smartest Way Of Cricket Gambling For Everyone</strong>
                                    </p>
                                    <p>
                                        Whether you are a new player looking to start on their online betting
                                        journey or a seasoned player looking for a new platform for online
                                        gambling, {DMNNM} will be perfect for you. We offer smart sports gambling
                                        solutions for everyone. We understand that customer experience is built on
                                        creating a quality experience, fair play, clear rules of the game, and
                                        transparency, and we deliver on all these parameters. So, we have already
                                        earned the trust of numerous clients and are looking forward to earning
                                        your trust as well. Give us a try, and you will realize that {DMNNM} is
                                        truly the smartest way of cricket gambling for everyone.
                                    </p>


                                </div>
                            </div>

                        </div>
                    </section>
                </div>


                <Loginb2cFooter history={this.props.history}></Loginb2cFooter>


            </div>)

    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExchangeTennisSEO);